import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import UISelect from 'UIComponents/input/UISelect';
import UILink from 'UIComponents/link/UILink'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message

import UITypeaheadResultsItem from 'UIComponents/typeahead/results/UITypeaheadResultsItem';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import { requestIdleCallback } from '../../utils/requestIdleCallback';
import SearchBarContext from '../context/SearchBarContext';
import SearchBarInput from './SearchBarInput';

const NoopExternalIcon = () => null;

const SearchBarContextProvider = ({
  children,
  value
}) => /*#__PURE__*/_jsx(SearchBarContext.Provider, {
  value: value,
  children: children
});

export default function SearchBar(_ref) {
  let {
    categorySelectProps,
    inputSize = 'xl',
    inputValue,
    onClear,
    onInputValueChange,
    onOpenChange,
    onResultClick,
    onSearchSubmit,
    use = 'default'
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["categorySelectProps", "inputSize", "inputValue", "onClear", "onInputValueChange", "onOpenChange", "onResultClick", "onSearchSubmit", "use"]);

  const [searchInputValue, setSearchInputValue] = useState(inputValue);
  const [clearButtonClicked, setClearButtonClicked] = useState(false);
  const [open, setOpen] = useState(false);
  const isLink = use === 'link';
  const isExternalLink = use === 'external-link';
  const renderOption = useCallback(option => {
    if (option.href && (isLink || isExternalLink)) {
      const {
        href,
        linkUse,
        dropdownText,
        text
      } = option;
      return /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
        _useButton: false,
        message: true,
        option: Object.assign({}, option, {
          dropdownText: /*#__PURE__*/_jsx(UILink, {
            className: "display-block p-y-2 p-x-5",
            ExternalIcon: NoopExternalIcon,
            external: isExternalLink,
            href: href,
            onMouseDown: evt => {
              evt.stopPropagation();

              if (onResultClick) {
                onResultClick(option);
              }

              if (isExternalLink) {
                requestIdleCallback(() => setOpen(false), 500);
              }
            },
            use: linkUse,
            children: dropdownText || text
          })
        })
      });
    }

    return /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
      message: true,
      option: option
    });
  }, [isExternalLink, isLink, onResultClick]);
  const handleOpenChange = useCallback(({
    target: {
      value
    }
  }) => {
    if (clearButtonClicked) {
      setClearButtonClicked(false);
      return;
    }

    if (onOpenChange) {
      onOpenChange(value);
    }

    setOpen(value);
  }, [clearButtonClicked, onOpenChange]);
  const handleSubmit = useCallback(value => {
    setOpen(false);

    if (onSearchSubmit) {
      onSearchSubmit(value);
    }
  }, [setOpen, onSearchSubmit]);
  const handleInputValueChange = useCallback(e => {
    const value = e.target.value;
    const prevSearchInputValue = searchInputValue;

    if (!value.trim()) {
      setSearchInputValue('');

      if (prevSearchInputValue && onClear) {
        onClear();
      }
    } else {
      setSearchInputValue(value);

      if (onInputValueChange) {
        onInputValueChange(e);
      }
    } // TODO related to https://git.hubteam.com/HubSpot/UIComponents/issues/7365


    if (e instanceof SyntheticEvent.constructor) {
      setClearButtonClicked(true);
    }
  }, [onClear, onInputValueChange, searchInputValue]);
  const handleInputKeyDown = useCallback(e => {
    const {
      key,
      target: {
        value: _value
      }
    } = e;

    const value = _value.trim();

    if (value && key === 'Enter') {
      e.preventDefault();
      handleSubmit(value);
    }
  }, [handleSubmit]);
  useEffect(() => {
    setSearchInputValue(inputValue);
  }, [inputValue]);
  return /*#__PURE__*/_jsx(SearchBarContextProvider, {
    value: {
      categorySelectProps,
      inputSize
    },
    children: /*#__PURE__*/_jsx(UISelect, Object.assign({}, rest, {
      anchorType: "input",
      cache: false,
      "data-test-id": "storefront-search-bar",
      filterOptions: false,
      inputComponent: SearchBarInput,
      inputValue: searchInputValue,
      onInputKeyDown: handleInputKeyDown,
      onInputValueChange: handleInputValueChange,
      onOpenChange: handleOpenChange,
      open: open,
      optionRenderer: renderOption,
      value: null
    }))
  });
}